export default __webpack_public_path__ + "static/media/download.6b15ae60.svg";